import { render, staticRenderFns } from "./videoiframe.vue?vue&type=template&id=7e94d4aa&"
import script from "./videoiframe.vue?vue&type=script&lang=js&"
export * from "./videoiframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e94d4aa')) {
      api.createRecord('7e94d4aa', component.options)
    } else {
      api.reload('7e94d4aa', component.options)
    }
    module.hot.accept("./videoiframe.vue?vue&type=template&id=7e94d4aa&", function () {
      api.rerender('7e94d4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8cHUXqhXUTdLA/JS/videoiframe.vue"
export default component.exports